import * as React from 'react';
import * as Muicon from "@mui/icons-material";
import { styled } from "@mui/material/styles";

import {FlexRowWrapper} from "../../elements/Row";
import { PreParagraph, Title } from "../../elements/Header";
import './styles.scss';

const CustomDiv = styled(`div`)(() => ({
  padding: '1rem',
  position: 'relative',
}));

const CustomTitle = styled(Title)`
  color: #132128;
  font-size: 1.2rem;
  font-weight: 400;
  margin-left: 0.5rem;
`

export default function PerkCard(props) {
  const [isHovered, setIsHovered] = React.useState(false);
  const Icon = Muicon[props?.perkItem?.icon];

  const handleEditClick = (event, perkItemIndex) => {
    event.stopPropagation();
    props?.handleEditPerk(perkItemIndex);
  };

  const handleDeleteClick = (event, perkItemIndex, perkItem) => {
    event.stopPropagation();
    props?.handleDeletePerk(perkItemIndex, perkItem);
  };


  return (
    <CustomDiv
      className={`${props?.cardMode !== "perkModal" ? 'perk-card-border' : 'perk-modal-card-border'} ${!!props?.isSelected && props?.cardMode === "perkModal" ? 'perk-card-border-success' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {
        props?.cardMode === "perkModal" ?
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>
              {Icon && <Icon />}
            </div>
            <div>
              <CustomTitle>
                <FlexRowWrapper>
                  {props?.perkItem?.title || ""}
                </FlexRowWrapper>
              </CustomTitle>
            </div>
          </div>
        : <>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
            {Icon && <Icon />}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <Title>
              <FlexRowWrapper>
                {props?.perkItem?.title || ""}
              </FlexRowWrapper>
            </Title>
          </div>
        </>
      }
      {isHovered && (
        <div style={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}>
          {
            !!props?.isEdit ?
              <Muicon.EditOutlined style={{ marginRight: '0.5rem', cursor: 'pointer', color: '#ff9800'}} onClick={(e) => handleEditClick(e, props?.perkItemIndex)} />
            : null
          }
          {
            !!props?.isDelete ?
              <Muicon.DeleteOutlineOutlined style={{ cursor: 'pointer', color: '#ef5350' }} onClick={(e) => handleDeleteClick(e, props?.perkItemIndex, props?.perkItem)} />
            : null
          }
        </div>
      )}
      {
        props?.cardMode !== "perkModal" ?
          <PreParagraph style={{ textAlign: "justify", marginTop: '0.5rem', marginBottom: '0.5rem' }} className='truncate-to-3-lines'>
            {props?.perkItem?.description || ""}
          </PreParagraph>
        : null
      }
    </CustomDiv>
  );
}